


export const LoadColumnas = (data, setColumnas) =>{
    let array = []
    let row;

    if (data.nombre1 !== '' && data.descripcion1 !== ''){
        row = {
            id: 1,
            nombre: data.nombre1,
            descripcion: data.descripcion1
        }
        array.push(row)
    }
    if (data.nombre2 !== '' && data.descripcion2 !== ''){
        row = {
            id: 2,
            nombre: data.nombre2,
            descripcion: data.descripcion2
        }
        array.push(row)
    }
    if (data.nombre3 !== '' && data.descripcion3 !== ''){
        row = {
            id: 3,
            nombre: data.nombre3,
            descripcion: data.descripcion3
        }
        array.push(row)
    }
    if (data.nombre4 !== '' && data.descripcion4 !== ''){
        row = {
            id: 4,
            nombre: data.nombre4,
            descripcion: data.descripcion4
        }
        array.push(row)
    }
    if (data.nombre5 !== '' && data.descripcion5 !== ''){
        row = {
            id: 5,
            nombre: data.nombre5,
            descripcion: data.descripcion5
        }
        array.push(row)
    }
    if (data.nombre6 !== '' && data.descripcion6 !== ''){
        row = {
            id: 6,
            nombre: data.nombre6,
            descripcion: data.descripcion6
        }
        array.push(row)
    }
    if (data.nombre7 !== '' && data.descripcion7 !== ''){
        row = {
            id: 7,
            nombre: data.nombre7,
            descripcion: data.descripcion7
        }
        array.push(row)
    }
    if (data.nombre8 !== '' && data.descripcion8 !== ''){
        row = {
            id: 8,
            nombre: data.nombre8,
            descripcion: data.descripcion8
        }
        array.push(row)
    }
    if (data.nombre9 !== '' && data.descripcion9 !== ''){
        row = {
            id: 9,
            nombre: data.nombre9,
            descripcion: data.descripcion9
        }
        array.push(row)
    }
    if (data.nombre10 !== '' && data.descripcion10 !== ''){
        row = {
            id: 10,
            nombre: data.nombre10,
            descripcion: data.descripcion10
        }
        array.push(row)
    }

    setColumnas(array)
}